import * as React from 'react';

import { DropdownMenu as RadixDropdownMenu } from '@radix-ui/themes';

// Wrappers for Radix DropdownMenu to use ListItem as asChild
export const DropdownMenu = RadixDropdownMenu.Root;
export const DropdownMenuTrigger = RadixDropdownMenu.Trigger;
export const DropdownMenuContent = RadixDropdownMenu.Content;
export const DropdownMenuSeparator = RadixDropdownMenu.Separator;
export const DropdownMenuLabel = RadixDropdownMenu.Label;
export const DropdownMenuGroup = RadixDropdownMenu.Group;

// Sub with asChild support
export const DropdownMenuSub: React.FC<
  React.ComponentPropsWithoutRef<typeof RadixDropdownMenu.Sub> & {
    asChild?: boolean;
  }
> = props => <RadixDropdownMenu.Sub {...props} />;
DropdownMenuSub.displayName = 'DropdownMenuSub';

// SubTrigger with asChild support for ListItem
export const DropdownMenuSubTrigger = React.forwardRef<
  HTMLDivElement,
  React.ComponentPropsWithoutRef<typeof RadixDropdownMenu.SubTrigger> & {
    asChild?: boolean;
  }
>((props, ref) => <RadixDropdownMenu.SubTrigger ref={ref} {...props} />);
DropdownMenuSubTrigger.displayName = 'DropdownMenuSubTrigger';
export const DropdownMenuSubContent = RadixDropdownMenu.SubContent;

// Item with asChild support for ListItem
export const DropdownMenuItem = React.forwardRef<
  HTMLDivElement,
  React.ComponentPropsWithoutRef<typeof RadixDropdownMenu.Item> & {
    asChild?: boolean;
  }
>((props, ref) => <RadixDropdownMenu.Item ref={ref} {...props} />);
DropdownMenuItem.displayName = 'DropdownMenuItem';

// Usage example:
// <DropdownMenu>
//   <DropdownMenuTrigger>Open menu</DropdownMenuTrigger>
//   <DropdownMenuContent>
//     <DropdownMenuItem asChild>
//       <ListItem startIcon={<Icon />} primary="Item 1" hotkey="⌘1" />
//     </DropdownMenuItem>
//     <DropdownMenuSeparator />
//     <DropdownMenuItem asChild>
//       <ListItem primary="Item 2" />
//     </DropdownMenuItem>
//   </DropdownMenuContent>
// </DropdownMenu>
